<template lang="pug">
app-page(:fabItems="fabItems" title="Управление пользователем" :loading="loading")
  app-toolbar(title="Пользователь" back)

  v-layout(v-if="currentUser")
    v-flex(xs6)
      app-card(@click.native="dialog.userControl=true")
        app-card-header
          app-card-title
            b Логин: {{ currentUser.login }}
        app-card-body
          app-card-caption.mb-2
            card-row-label-value(label="ФИО" :value="currentUser.fio" )
            card-row-label-value(label="Телефон" :value="currentUser.phone")
            card-row-label-value(label="E-mail" :value="currentUser.email")

      .sud-block-title Список ролей
      app-group-animation
        app-group-item(v-for="(g, index) in currentUser.grants" :key="index" cols="12")
          app-card( @click.native="writerUserFormDel('del', g)")
            app-card-body
              app-card-title {{ getGrantType(g.grantType) }}
                span(v-for="(j, index) in judges" :key="index")
                  span(v-if="j.id == g.locationObj")  - {{ isNull(j.lastName) }} {{ isNull(j.firstName) }} {{ isNull(j.middleName) }} ({{j.court.alias}})
              app-card-caption(v-if="g.location") Алиас суда: {{ g.location }}

      app-dialog(v-model="dialog.userControl" header="Управление пользователем" :items="userItems")

      //- user-change-pswd(v-model="dialog.changePassword" ref="changePassword" :userId="currentUser.id")
      app-dialog(v-model="dialog.changePassword" ref="changePassword" header="Сменить пароль")
        v-form(ref="formPassword")
          app-text-field(
            v-model="form.password" 
            :rules="[rules.required]"
            :append-icon="showPSWD ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPSWD ? 'text' : 'password'"
            @click:append="showPSWD = !showPSWD"
            label="Пароль"
          )

          app-text-field(
            v-model="form.passwordConfirm" 
            :rules="[rules.required, passwordConfirmationRule]"
            :type="showPSWD ? 'text' : 'password'"
            hint="Неверный пароль"
            label="Повторите пароль"
          )
          app-button-action(@click="changePassword()") сменить
      

      app-dialog-confirm(v-model="dialog.delGrant" @confirm="controlUserGrant()")
        app-card-title.mt-5 
          b Вы точно хотите удалить роль?

      app-dialog(v-model="dialog.addGrant" header="Добавить роль")
        v-form(ref="formGrants")
          app-select(v-model="form.grants" :items="grantsItems" item-text="titleRu" item-value="title" :rules="[rules.requiredcombo]" label="Выбрать роль" multiple)
          app-select(v-if="showSelectJudges()" v-model="form.locationObj" :items="judges" :rules="[rules.requiredcombo]" label="Выбрать судью"  item-text="lastName" item-value="id")
          app-button-action(@click="controlUserGrantAdd()") добавить

      app-dialog(v-model="dialog.userCreate" ref="userCreate" header="Редактировать пользователя")
        v-form(ref="newUserForm")
          app-text-field(v-model="currentUser.fio" :rules="[rules.required]" label="ФИО")
          app-text-field(v-model="currentUser.phone" label="Телефон")
          app-text-field(v-model="currentUser.email" label="E-mail")
          app-button-action(@click="userUpdate()") добавить
</template>

<script>
import { userService } from "@/_services";
import { mapState, mapMutations, mapGetters } from 'vuex'
import { AppDialogConfirm  } from '@/components'
import { $_validate_rules } from '@/common/ValidateRules'
import CardRowLabelValue from '../components/CardRowLabelValue'
// import changePswdUser from './components/changePswdUser'

export default {
  mixins: [$_validate_rules],

  props: {
    userId: String
  },

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    CardRowLabelValue,
    // [changePswdUser.name]: changePswdUser
  },

  data () {
    return {
      judge: '',
      dialog: {
        changePassword: false,
        addGrant: false,
        delGrant: false,
        userCreate: false,
        userControl: false,
      },
      form: {
        id: 0,
        login: '',
        grants: [],
        locationObj:'',
        action:'',
        password:'',
        passwordConfirm: '',
      },
      showPSWD: false,
      loading: false
    }
  },

  mounted () {
    this.$store.commit('setInUsers', true)
    this.$store.dispatch('users/INIT')
    this.$store.dispatch('users/LOAD_USER', this.userId)
  },

  computed: {
    ...mapState('users', ['currentUser']),
    ...mapGetters('users', ['users', 'grants', 'judges']),

    fabItems () {
      return [{ icon: 'add', title: 'Добавить роль', action: () => this.writerUserForm('add') }]
    },

    grantsItems () {
      return this.grants.filter(grant => grant.name != 'SPECIALIST')
    },

    userItems () {
      return [
        { icon: 'edit', title: 'Редактировать', action: () => this.$refs.userCreate.show() },
        { icon: 'edit', title: 'Сменить пароль', action: () => this.$refs.changePassword.show() },
      ]
    },

    passwordConfirmationRule () {
      return this.form.password === this.form.passwordConfirm || 'Неверный пароль'
    }
  },

  methods: {
    ...mapMutations('users', ['setCurrentUser', 'setUsers', 'setUserInUsers']),

    changePassword () {
      if (this.$refs.formPassword.validate()) {
        this.form.id = this.userId
        this.dialog.changePassword = false
        userService.changePassword(this.form)
      }
    },

    getGrantType (grant) {
      return this.grants.find(g => g.title == grant).titleRu
    },

    showSelectJudges () {
      return this.form.grants.find(item => item == "JUDGE" || item == "JUDGEHELPER" )
    },

    isNull (text) {
      return text ? text : ''
    },

    createUserForm (action) {
      this.form.action = action
      this.form.id = this.currentUser.id
      this.form.grants = []
    },

    writerUserForm (action) {
      this.createUserForm(action)
      this.dialog.addGrant = true
    },

    isDelGrant (grant) {
      if (this.currentUser.login === localStorage.getItem("LoginName")) 
        if (grant.grantType === "ADMIN" || grant.grantType === "DEVELOPER") return false
      return true
    },

    writerUserFormDel (action, grant) { 
      if (this.isDelGrant(grant)) {
        this.createUserForm(action)
        this.form.grants.push(grant)
        this.dialog.delGrant = true
      }
    },

    controlUserGrantAdd () {
      if (this.$refs.formGrants.validate()) this.controlUserGrant()
    },

    createGrantObj (locationObj, grantType) {
        return {
          "grantType": grantType,
          "location": "",
          "locationObj": locationObj ? locationObj : ''
        }
    },

    userUpdate () {
        let obj = {
          id: this.currentUser.id,
          fio: this.currentUser.fio ? this.currentUser.fio : "",
          phone: this.currentUser.phone ? this.currentUser.phone : "",
          email: this.currentUser.email ? this.currentUser.email : ""
        }
        userService.userUpdate(obj).then(() => {
          this.setUserInUsers(this.currentUser)
          this.dialog.userCreate = false 
        })
    },

    createUserObj () {
        return {
          "id": this.currentUser.id,
          "login": this.currentUser.login,
          "password": null,
          "grants": this.createArrayGrants()
        }
    },

    createArrayGrants () {
        let grants = []
        if (this.form.action == 'add') {
            this.form.grants.map(grant => grants.push(this.createGrantObj(this.form.locationObj, grant)) )
            grants = [...grants, ...this.currentUser.grants]
        } 
        else grants.push(this.form.grants[0])

        return grants
    },
 
    controlUserGrant () {
      this.loading = true
      userService.addGrant(this.createUserObj (), this.form.action).then(() => {
        this.$store.dispatch('users/LOAD_USER', this.userId)

        if (this.form.action=='del' && this.currentUser.grants.length == 1) {
          let users = this.users.filter(user => user.login != this.login)
          this.setUsers(users)
          this.$router.push({ path: `/admin/users` })
        }

        this.dialog.addGrant = false
        this.loading = false
      })
    },

  },

  beforeDestroy() {
    this.$store.commit('setInUsers', false)
  }
}
</script>